export default __webpack_public_path__ + "6668113afd31f55c8b64a423328f5531.png";